var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 .64C7.517.64.64 7.517.64 16S7.517 31.36 16 31.36 31.36 24.483 31.36 16 24.483.64 16 .64zm3.638 10.614h-2.309c-.274 0-.578.36-.578.838v1.667h2.888l-.437 2.378h-2.451v7.138h-2.725v-7.138h-2.472v-2.378h2.472v-1.398c0-2.006 1.392-3.637 3.302-3.637h2.309v2.53z"
  })));
};
export default SvgFacebook;